<div
    class="d-flex flex-wrap justify-content-between align-items-center mb-4 p-3 bg-white shadow-sm rounded-3">
    <!-- Controles de navegación -->
    <div class="d-flex align-items-center flex-wrap gap-2">
        <button
            class="btn btn-outline-success btn-sm d-flex align-items-center"
            (click)="onPaginaAnterior()"
            [disabled]="paginaActual === 1">
            <i class="bi bi-chevron-left me-1"></i>
            Anterior
        </button>

        <span class="text-secondary small mx-2">
            Página
            <strong>{{ paginaActual }}</strong>
            de
            <strong>{{ totalPaginas }}</strong>
            ({{ totalRegistros }} {{ textoRegistros }})
        </span>

        <button
            class="btn btn-outline-success btn-sm d-flex align-items-center"
            (click)="onPaginaSiguiente()"
            [disabled]="paginaActual === totalPaginas">
            Siguiente
            <i class="bi bi-chevron-right ms-1"></i>
        </button>
    </div>
    <a
        *ngIf="mostrarEnlaceRelacionar"
        class="badge text-dark rounded-3 px-4 py-3 bg-success-subtle text-decoration-none fs-6"
        [routerLink]="['/registro-productos-comercializadores']">
        Relacionar productos
    </a>
    <!-- Selector de límite -->
    <div class="d-flex align-items-center gap-2">
        <label
            for="mostrarPresentaciones"
            class="form-label mb-0 small text-secondary">
            {{ textoMostrar }}:
        </label>
        <select
            id="mostrarPresentaciones"
            class="form-select form-select-sm shadow-sm"
            style="width: auto"
            [(ngModel)]="limite"
            (change)="onCambiarLimite()">
            <option
                *ngFor="let cantidadDatos of opcionesLimite"
                [value]="cantidadDatos">
                {{ cantidadDatos }}
            </option>
        </select>
    </div>
</div>
